import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";

const CALENDLY = "https://calendly.com/katie-fernands/discovery-call";

export function StickyHeader() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "py-3" : "py-6"
      }`}
    >
      <div
        className={`mx-auto max-w-7xl px-6 lg:px-10 flex items-center justify-between transition-colors duration-500 ${
          scrolled ? "text-foreground" : "text-white"
        }`}
      >
        <a
          href="#top"
          className="flex items-baseline gap-2 font-serif text-lg tracking-tight"
        >
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary translate-y-[-2px]" />
          Katie Fernands
        </a>
        <div className="flex items-center gap-6">
          <Link
            to="/blog"
            className={`text-sm tracking-wide border-b pb-1 transition-all ${
              scrolled
                ? "border-foreground/40 hover:border-primary hover:text-primary"
                : "border-white/40 hover:border-primary hover:text-primary"
            }`}
          >
            Insights
          </Link>
          <Link
            to="/headline"
            className={`text-sm tracking-wide border-b pb-1 transition-all ${
              scrolled
                ? "border-foreground/40 hover:border-primary hover:text-primary"
                : "border-white/40 hover:border-primary hover:text-primary"
            }`}
          >
            Free headline fix
          </Link>
          <Link
            to="/newsletter"
            className={`text-sm tracking-wide border-b pb-1 transition-all ${
              scrolled
                ? "border-foreground/40 hover:border-primary hover:text-primary"
                : "border-white/40 hover:border-primary hover:text-primary"
            }`}
          >
            Newsletter
          </Link>
          <Link
            to="/contact"
            className={`text-sm tracking-wide border-b pb-1 transition-all ${
              scrolled
                ? "border-foreground/40 hover:border-primary hover:text-primary"
                : "border-white/40 hover:border-primary hover:text-primary"
            }`}
          >
            Contact
          </Link>
          <a
            href={CALENDLY}
            target="_blank"
            rel="noopener noreferrer"
            className={`text-sm tracking-wide border-b pb-1 transition-all ${
              scrolled
                ? "border-foreground/40 hover:border-primary hover:text-primary"
                : "border-white/40 hover:border-primary hover:text-primary"
            }`}
          >
            Schedule &nbsp;→
          </a>
        </div>
      </div>
    </header>
  );
}
